class AnalyticsOnClickController {
    constructor($element, gtmService) {
        this.gtmService = gtmService;
        $element.on('click', () => {
            this.gtmService.push({ event: this.event });
        });
    }
}

const analyticsOnClickDirectiveDefinition = () => ({
    restrict: 'A',
    scope: {},
    bindToController: {
        event: '@olyAnalyticsOnClick',
    },
    controller: ['$element', 'GtmService', AnalyticsOnClickController],
    controllerAs: 'analyticsOnClickCtrl',
});

module.exports = {
    AnalyticsOnClickController,
    analyticsOnClickDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/analytics/analytics/analytics-on-click.directive.js